// import { auth, isLoggedIn } from "@/middlewares";
import { auth, reports_enabled, options_enabled } from "@/middlewares";
import ListDTPage from '@/views/ListDTPage';
// import store from '@/store';

export default [
  // {
  //   path: "/",
  //   name: "Index",
  //   component: () => import("../views/IndexPage.vue"),
  //   meta: {
  //     layout: 'DefaultLayout',
  //   },
  // },
  // {
  //   path: "/",
  //   name: "RouterIndexPage",
  //   component: () => import("../views/IndexPage.vue"),
  //   meta: {
  //     layout: 'DefaultLayout',
  //     middlewares: [auth],
  //   },
  // },
  {
    path: "/",
    redirect: () => {
      //{ path: 'listdt'}
      return 'listdt'
    },    
  },
  {
    path: "/listdt",
    name: "RouterListDTPage",
    component: ListDTPage,
    meta: {
      layout: 'DefaultLayout',
      middlewares: [auth],
    },    
  },
  {
    path: "/login",
    name: "RouterLoginPage",
    component: () => import("../views/LoginPage.vue"),
    meta: {
      layout: 'DefaultLayout'
      //middlewares: [auth, isLoggedIn],
    },
  },
  {
    path: "/listdt/:nd",
    name: "RouterDTPage",
    props: true, 
    component: () => import("../views/DTPage.vue"),
    meta: {
      layout: 'DefaultLayout',
      middlewares: [auth],
    },
  },
  {
    path: "/options",
    name: "OptionsPage",
    props: true, 
    component: () => import("../views/OptionsPage.vue"),
    meta: {
      layout: 'DefaultLayout',
      middlewares: [auth, options_enabled],
    },
    // beforeEnter: (to, from, next) => {
    //   if (store.state.Auth.user.options_enabled == 0) {
    //     return
    //   } else
    //   next()
    // }
  },
  {
    path: "/reports",
    name: "ReportsPage",
    props: true, 
    component: () => import("../views/ReportsPage.vue"),
    meta: {
      layout: 'DefaultLayout',
      middlewares: [auth],
    },

  },
  {
    path: "/frreport",
    name: "RouterFrReportPage",
    props: true, 
    component: () => import("../views/FrReportPage.vue"),
    meta: {
      layout: 'DefaultLayout',
      middlewares: [auth, reports_enabled],
    },
    // beforeEnter: (to, from, next) => {

    //   if (store.state.Auth.user.reports_enabled == 0) {
    //     return
    //   } else 
    //   next()
    // }
  },
  {
    path: '/fastreport' ,
    meta: {
      middlewares: [auth],
    },
  },
  // {
  //   path: "/cart",
  //   name: "Cart",
  //   component: () => import("../views/Cart.vue"),
  // },
  // {
  //   path: "/orders",
  //   name: "Orders",
  //   component: () => import("../views/Orders.vue"),
  //   meta: {
  //     layout: "AppLayoutProfile",
  //     middlewares: [auth],
  //   },
  // },
  // {
  //   path: "/profile",
  //   name: "Profile",
  //   component: () => import("../views/Profile.vue"),
  //   meta: {
  //     layout: "AppLayoutProfile",
  //     middlewares: [auth],
  //   },
  // },
];